import { useTranslation } from 'react-i18next';

import useGetBookingCustomButtonData from '../../../hooks/useGetBookingCustomButtonData';
import { useRootSelector } from '../../../../../store/hooks';

import Button, { ButtonProps } from '../../library/Button';
import { selectSiteHeader } from '../../../../../store/features/siteHeader';

interface BookingButtonProps extends ButtonProps {}

export default function BookingButton(props: BookingButtonProps) {
  const { children, href = '/purchase/select-package', ...buttonProps } = props;
  const { t } = useTranslation();
  const {
    data: { booking },
  } = useRootSelector(selectSiteHeader);
  const { customLabel, customUrl } = useGetBookingCustomButtonData();
  const buttonLabel = customLabel ?? children ?? t('site.pricing.book-now');

  return booking ? (
    <Button href={customUrl ?? href} {...buttonProps}>
      {buttonLabel}
    </Button>
  ) : null;
}
